import React from 'react';
import { cn } from 'shared/lib/cn';

export type LedButtonProps = { on: boolean; onToggle: () => void; label: string; ariaLabel: string; disabled?: boolean; className?: string };

/** A latching button with a lit indicator — used for End-to-End Encryption. */
export function LedButton({ on, onToggle, label, ariaLabel, disabled, className }: LedButtonProps) {
  return (
    <button
      type="button"
      aria-pressed={on}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={onToggle}
      className={cn(
        'inline-flex h-9 items-center gap-2 rounded-[var(--radius-2)] border px-3 font-body text-xs transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/60 disabled:opacity-50',
        on ? 'border-ok/50 bg-ok/10 text-ok' : 'border-hairline/25 bg-surface-high text-ink-muted',
        className,
      )}
    >
      <span className={cn('h-2 w-2 rounded-full', on ? 'bg-ok' : 'bg-ink-muted')} />
      {label}
    </button>
  );
}
